import { z } from 'zod';

// Contrato de los documentos controlados de cada versión (spec 2026-10-20 §6.9), validado
// con Zod (ENG-VAL-01): un drift del backend cae al estado de error de la consulta. Los
// ids llegan como string (serializador de bigint).

export const CONTROLLED_FILE_KINDS = ['control_cambios', 'editable', 'pdf_vigente'] as const;
export type ControlledFileKind = (typeof CONTROLLED_FILE_KINDS)[number];

export const VERSION_STATUSES = ['vigente', 'pendiente_vigencia', 'obsoleto'] as const;
export type VersionStatus = (typeof VERSION_STATUSES)[number];

const fileSchema = z.object({
  id: z.string(),
  kind: z.enum(CONTROLLED_FILE_KINDS),
  fileName: z.string(),
  contentType: z.string(),
  sizeBytes: z.number().int().nonnegative(),
  sha256: z.string(),
  createdAt: z.string(),
});
export type ControlledFile = z.infer<typeof fileSchema>;

const versionSchema = z.object({
  version: z.number().int().positive(),
  status: z.enum(VERSION_STATUSES),
  files: z.array(fileSchema),
});
export type ControlledVersion = z.infer<typeof versionSchema>;

const listSchema = z.object({
  entryId: z.string(),
  code: z.string(),
  versions: z.array(versionSchema),
});
export type ControlledFiles = z.infer<typeof listSchema>;

export const controlledFilesResponseSchema = z.object({
  success: z.literal(true),
  data: listSchema,
});

const downloadSchema = z.object({
  url: z.string().url(),
  fileName: z.string(),
  expiresInSeconds: z.number().int().positive(),
});
export type ControlledFileDownload = z.infer<typeof downloadSchema>;

export const controlledFileDownloadResponseSchema = z.object({
  success: z.literal(true),
  data: downloadSchema,
});
